module.exports = __webpack_public_path__ + "img/kit.6d07d0a8.png";